// extracted by mini-css-extract-plugin
export default {"strip_wrapper":"Strip_strip_wrapper__Vhqll","strip_text":"Strip_strip_text__AGy2e"};